/* eslint-disable import/first, import/newline-after-import */

import 'utils/tags_carousel_component/tags-carousel-component';
import 'components/resources/show/resource-related/resource-related';
import 'components/partner/search/sponsored-results/sponsored-results';

import EezyStimulusApplication from 'packs/eezy-stimulus'; // eslint-disable-line import/order

import EzCarouselController from 'components/util/ez-carousel/ez-carousel-controller';
EezyStimulusApplication.register('ez-carousel', EzCarouselController);

import SearchTagController from 'components/search/search-tags/search-tag-controller';
EezyStimulusApplication.register('search-tag', SearchTagController);

import PartnerSponsoredResultsController from 'components/partner/search/sponsored-results/sponsored-results-controller';
EezyStimulusApplication.register('partner-sponsored-results', PartnerSponsoredResultsController);

import RelatedGridsController from 'components/resources/show/resource-related/related-grids-controller';
EezyStimulusApplication.register('related-grids', RelatedGridsController);

import RelatedTagsController from 'components/resources/show/resource-related/related-tags-controller';
EezyStimulusApplication.register('related-tags', RelatedTagsController);
